import { Dayjs } from 'dayjs';

const isoDateFormat = 'YYYY-MM-DD';

export function datesEqual(date1: Dayjs, date2: Dayjs): boolean {
    return date1.format(isoDateFormat) === date2.format(isoDateFormat);
}
